import { useDispatch } from "react-redux";
import Wrapper from "../assets/wrappers/Job";
import { Link } from "react-router-dom";
import JobInfo from "./JobInfo";
import { FaBriefcase, FaCalendar, FaLocationArrow } from "react-icons/fa";
import moment from "moment";
import { deleteJob, setEditJob } from "../features/job/jobSlice";

function Job({ _id, position, company, jobLocation, jobType, status, createdAt }) {
  const dispatch = useDispatch();
  const date = moment(createdAt).format("MMM Do, YYYY");
  return (
    <Wrapper>
      <header>
        <div className="main-icon">{company.charAt(0)}</div>
        <div className="info">
          <h5>{position}</h5>
          <p className="company">{company}</p>
        </div>
      </header>
      <div className="content">
        <div className="content-center">
          <JobInfo icon={<FaLocationArrow />} text={jobLocation} />
          <JobInfo icon={<FaCalendar />} text={date} />
          <JobInfo icon={<FaBriefcase />} text={jobType} />
          <div className={`status ${status}`}>{status}</div>
        </div>
      </div>
      <footer>
        <div className="actions">
          <Link
            to="/add-job"
            className="btn edit-btn"
            onClick={() =>
              dispatch(
                setEditJob({
                  editJobId: _id,
                  position,
                  company,
                  jobLocation,
                  jobType,
                  status,
                }),
              )
            }
          >
            Edit
          </Link>
          <button
            type="button"
            className="btn delete-btn"
            onClick={() => dispatch(deleteJob(_id))}
          >
            Delete
          </button>
        </div>
      </footer>
    </Wrapper>
  );
}

export default Job;
